class Loading {
    constructor() {
        this.isVisible = false;
        this.message = 'Processando...';
        this.status = 'loading';
        this.time = 3000;
        this.timer = null;

        EventBus.$on('loading-show', () => {
            this.show();
        });

        EventBus.$on('loading-hide', () => {
            this.hide();
        });

        EventBus.$on('loading-updateStatus', (update) => {
            this.setStatus(update.status);
            this.setMessage(update.message);
        });


    }

    setStatus(status) {
        this.status = status;
    }

    setMessage(message) {
        this.message = message;
    }

    show() {
        if (!this.isVisible) {
            this.isVisible = true;
        } else {
            this.reset();
            setTimeout(() => this.isVisible = true, 300);
        }
    }

    hide() {
        this.timer = setTimeout(() => this.reset(), this.time);
    }

    reset() {
        this.timer && clearTimeout(this.timer);
        this.isVisible = false;
        setTimeout(() => {
            this.status = 'loading';
            this.message = 'Processando...';
        }, 300);
    }
}

export default Loading;
